export default {
  init() {
    // JavaScript to be fired on the home page
    $('#owl-demo').owlCarousel({
 
      loop:true,
      margin:10,
      pagination: true, 
      autoplay:true,
      autoplayTimeout:4000,
      responsive:{
          0:{
              items:1,
          },
          600:{
              items:1,
          },
          1000:{
              items:1,
          },
      },
 
  });



  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js